export default {
  fourKankan: '4dKankan',
  krpanpo: 'krpanpo',
};
